(function (window, document, $) {

    $(document).ready(function () {
        if ($('[data-yogatv-onboarding]').length || $('[data-yogatv-onboarding-slider]').length) {
            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'get_onboarding_data',
                    page: themevars.post_id,
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {
                if (true !== result.success) {
                    return;
                }

                if ($('[data-yogatv-onboarding]').length && result.data.onboarding_cta) {
                    $('[data-yogatv-onboarding]').html(result.data.onboarding_cta).removeClass('d-none');
                }

                if ($('[data-yogatv-onboarding-slider]').length && result.data.onboarding_slider) {
                    $('[data-yogatv-onboarding-slider]').html(result.data.onboarding_slider);
                    
                    let event = new CustomEvent('init-onboarding-slider');
                    document.dispatchEvent(event);

                    $(document).trigger('wpgu-set-favorites-selected');
                }
            });
        }

        $(document).on('click', '[data-wpgu-onboarding-close]', function(e) {
            $('[data-onboarding-section]').addClass('d-none');
        });
    });

}(window, document, jQuery));
